import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getNewsCategories = async () => {
  const response = await axios.get(`${base_url}category/getAllCat`);

  return response.data;
};
const createNewsCategory = async (bcat) => {
  const response = await axios.post(`${base_url}category/addCategory`, bcat, config);

  return response.data;
};
const updateNewsCategory = async (NewsCat) => {
  const response = await axios.put(
    `${base_url}category/editCategory/${NewsCat.id}`,
    { category_name: NewsCat.NewsCatData.category_name }
  );

  return response.data;
};
const getNewsCategory = async (id) => {
  const response = await axios.get(`${base_url}category/getCat/${id}`, config);

  return response.data;
};

const deleteNewsCategory = async (id) => {
  const response = await axios.delete(`${base_url}category/deleteCategory/${id}`, config);

  return response.data;
};
const bCategoryService = {
  getNewsCategories,
  createNewsCategory,
  deleteNewsCategory,
  getNewsCategory,
  updateNewsCategory,
};

export default bCategoryService;
